<template>
<div>
    <v-card rounded="xl" elevation="5" class="mx-5 px-5 py-5 my-5">
      <v-card-title>
        {{ $t('local_settings.title') }}
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-checkbox outlined
            v-model="isBarcodeReaderEnabled"
            append-icon="mdi-barcode"
            v-bind:label="$t('local_settings.is_barcode_reader_enabled')">
          </v-checkbox>
          <v-checkbox outlined
            v-model="isLabelPrinterEnabled"
            append-icon="mdi-printer"
            v-bind:label="$t('local_settings.is_label_printer_enabled')">
          </v-checkbox>
          <v-text-field outlined
            v-model="clientAppUrl"
            :counter="255"
            append-icon="mdi-api"
            v-bind:label="$t('local_settings.client_app_url')">
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="mx-5 d-flex justify-end">
        <v-btn color="primary" @click="saveLocalSettings">
          {{ $t('common_actions.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar color="success"
      v-model="successDialogShow">
      {{ this.successDialogText }}
    </v-snackbar>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'

export default {
  name: 'LocalSettings',
  data: () => ({
    isBarcodeReaderEnabled: false,
    isLabelPrinterEnabled: false,
    clientAppUrl: '',
    successDialogShow: false,
    successDialogText: ''
  }),
  mounted () {
    this.isBarcodeReaderEnabled = this.comIsBarcodeReaderEnabled
    this.isLabelPrinterEnabled = this.comIsLabelPrinterEnabled
    this.clientAppUrl = this.comClientAppUrl
  },
  computed: {
    comIsBarcodeReaderEnabled () {
      return this.$store.state.localSettings.isBarcodeReaderEnabled
    },

    comIsLabelPrinterEnabled () {
      return this.$store.state.localSettings.isLabelPrinterEnabled
    },

    comClientAppUrl () {
      return this.$store.state.localSettings.clientAppUrl
    }
  },
  methods: {
    saveLocalSettings () {
      this.$store.dispatch('localSettings/updateLocalSettings', {
        isBarcodeReaderEnabled: this.isBarcodeReaderEnabled,
        isLabelPrinterEnabled: this.isLabelPrinterEnabled,
        clientAppUrl: this.clientAppUrl
      })

      this.successDialogShow = true
      this.successDialogText = i18n.t('local_settings.save_success')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/LocalSettings.vue